/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import { spacing } from "../../../../../global/emotion";
import type { HallowElement } from "../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import type { WithAsChild } from "../../../../types/withAsChild.types";
import { determineElementFromAsChild } from "../../../../utils/determineElementFromAsChild";

const hallowElement: HallowElement = "div";

const determinedElementStyle: Interpolation = {
  height: spacing.full,
  minWidth: 0,
  width: spacing.full,
};

export type GridItemProps = WithAsChild<
  HallowElementProps<typeof hallowElement>
>;

export const GridItem = forwardRef<any, GridItemProps>(
  ({ asChild = false, children, ...props }, ref) => {
    const DeterminedElement = determineElementFromAsChild({
      asChild,
      hallowElement,
    });

    return (
      <DeterminedElement ref={ref} css={determinedElementStyle} {...props}>
        {children}
      </DeterminedElement>
    );
  },
);

GridItem.displayName = "GridItem";
